// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/FirmLogin.tsx
// v1.0.0 - Adresse der Firma app.estata.com/<kurzname> (Inhaber 21.10.2026: "eine schoene URL fuer die Firmen" - ohne
//          Subdomain, Strato nimmt keinen *-Eintrag). Bekannte Firma: die Anmeldung mit dem Firmennamen darueber, nach
//          der Anmeldung direkt in diese Firma (Login + preferFirm). Unbekannter Name: die normale 404-Seite.
//          Alle Seiten der Website auf oberster Ebene sind als Kurzname belegt (SLUG_RESERVED im System-Backend).
import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import Login from "./Login.tsx";

const FIRM_SLUG = /^[a-z0-9][a-z0-9-]{1,48}[a-z0-9]$/;

const FirmLogin = () => {
  const { firm = "" } = useParams();
  const slug = firm.toLowerCase();
  const [state, setState] = useState<{ status: "checking" | "found" | "missing"; name?: string }>({ status: "checking" });

  useEffect(() => {
    if (!FIRM_SLUG.test(slug)) { setState({ status: "missing" }); return; }
    let cancelled = false;
    axios.get(`/system/api/v1/tenants/by-slug/${encodeURIComponent(slug)}`)
      .then((res) => { if (!cancelled) setState({ status: "found", name: res.data?.name || undefined }); })
      // Nur "gibt es nicht" fuehrt zur 404 - bei Bremse oder Netzfehler trotzdem anmelden, nur ohne Namen
      .catch((err) => { if (!cancelled) setState({ status: err?.response?.status === 404 ? "missing" : "found" }); });
    return () => { cancelled = true; };
  }, [slug]);

  if (state.status === "missing") return <Navigate to="/404" replace />;
  if (state.status === "checking") {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-black">
        <Loader2 className="w-8 h-8 text-white animate-spin" />
      </div>
    );
  }
  return <Login firm={{ slug, name: state.name }} />;
};

export default FirmLogin;
